export const sleep = (seconds: number): Promise<void> => {
    return new Promise((resolve) => {
        const id: any = setTimeout(() => resolve(id), seconds * 1000);
    });
};
